import { useEffect, useState } from "react";
import { api } from "@/lib/api";
import { Map as MapIcon } from "lucide-react";
import { MapBrowser } from "@/components/MapBrowser";

const BookChips = ({ label, books, active, onPick }) => (
  <div className="mt-6">
    <p className="font-mono text-[11px] uppercase tracking-[0.2em] text-gold mb-3">{label}</p>
    <div className="flex flex-wrap gap-2">
      {books.map(({ book, count }) => (
        <button key={book} data-testid={`gallery-book-${book.toLowerCase().replace(/\s+/g, "-")}`} onClick={() => onPick(book)}
          className={`px-3.5 py-1.5 rounded-full text-sm border transition-colors ${active === book
            ? "bg-ink text-parchment border-ink" : "bg-card border-border text-ink/70 hover:border-gold hover:text-ink"}`}>
          {book} <span className="opacity-50 text-xs">{count}</span>
        </button>
      ))}
    </div>
  </div>
);

export default function MapGallery() {
  const [books, setBooks] = useState({ old_testament: [], new_testament: [] });
  const [active, setActive] = useState("Genesis");

  useEffect(() => { api.get("/maps/books").then(({ data }) => setBooks(data)); }, []);

  return (
    <div data-testid="map-gallery-page" className="max-w-6xl mx-auto px-5 sm:px-8 pt-14 pb-16">
      <div className="max-w-2xl animate-rise">
        <span className="inline-flex items-center gap-2 font-mono text-xs uppercase tracking-[0.2em] text-gold mb-4">
          <MapIcon className="w-4 h-4" /> Casual English Bible® Atlas
        </span>
        <h1 className="font-serif text-4xl sm:text-5xl font-700 text-ink leading-tight">Bible Map Gallery</h1>
        <p className="mt-4 text-ink/70 leading-relaxed">
          Walk the lands of Scripture book by book — over a thousand maps by Stephen M. Miller, built from satellite data and the Bible.
        </p>
      </div>

      <BookChips label="Old Testament" books={books.old_testament} active={active} onPick={setActive} />
      <BookChips label="New Testament" books={books.new_testament} active={active} onPick={setActive} />

      <div className="mt-10 border-t border-border pt-8">
        <h2 data-testid="gallery-active-book" className="font-serif text-3xl font-600 text-ink mb-2">{active}</h2>
        <MapBrowser book={active} testid="gallery-maps" />
      </div>
      <p className="text-[11px] text-ink/45 mt-10">Maps © Stephen M. Miller, Casual English Bible® — used under publishing license.</p>
    </div>
  );
}
